var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318",
    transform: "translate(0.054)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-0.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M168-792a3.852,3.852,0,0,1-2.825-1.175A3.852,3.852,0,0,1,164-796a3.852,3.852,0,0,1,1.175-2.825A3.852,3.852,0,0,1,168-800a3.852,3.852,0,0,1,2.825,1.175A3.852,3.852,0,0,1,172-796a3.852,3.852,0,0,1-1.175,2.825A3.852,3.852,0,0,1,168-792Zm-8,8v-2.8a2.929,2.929,0,0,1,.438-1.562,2.916,2.916,0,0,1,1.163-1.088,14.844,14.844,0,0,1,3.15-1.162A13.757,13.757,0,0,1,168-791a13.757,13.757,0,0,1,3.25.388,14.844,14.844,0,0,1,3.15,1.162,2.916,2.916,0,0,1,1.163,1.088A2.929,2.929,0,0,1,176-786.8v2.8Zm2-2h12v-.8a.94.94,0,0,0-.137-.5.973.973,0,0,0-.363-.35,13.036,13.036,0,0,0-2.725-1.012A11.6,11.6,0,0,0,168-789a11.6,11.6,0,0,0-2.775.338,13.036,13.036,0,0,0-2.725,1.012.973.973,0,0,0-.363.35.94.94,0,0,0-.137.5Zm6-8a1.926,1.926,0,0,0,1.413-.588A1.926,1.926,0,0,0,170-796a1.926,1.926,0,0,0-.587-1.412A1.926,1.926,0,0,0,168-798a1.926,1.926,0,0,0-1.413.588A1.926,1.926,0,0,0,166-796a1.926,1.926,0,0,0,.587,1.412A1.926,1.926,0,0,0,168-794ZM168-796ZM168-786Z",
    transform: "translate(-152.129 807.771)",
    fill: "#1976d2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/user_blue.ef5cd38682afa99ec771f3e383b54a92.svg";
export { ForwardRef as ReactComponent };